"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.StreemApiAnalyticEventToolPlacedCallStatus = exports.StreemApiAnalyticEventToolPlacedToJSON = exports.StreemApiAnalyticEventToolPlacedFromJSONTyped = exports.StreemApiAnalyticEventToolPlacedFromJSON = void 0;
const runtime_1 = require("../runtime");
const _1 = require("./");
function StreemApiAnalyticEventToolPlacedFromJSON(json) {
    return StreemApiAnalyticEventToolPlacedFromJSONTyped(json, false);
}
exports.StreemApiAnalyticEventToolPlacedFromJSON = StreemApiAnalyticEventToolPlacedFromJSON;
function StreemApiAnalyticEventToolPlacedFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'roomSid': !(0, runtime_1.exists)(json, 'room_sid') ? undefined : json['room_sid'],
        'callStatus': !(0, runtime_1.exists)(json, 'call_status') ? undefined : json['call_status'],
        'laser': !(0, runtime_1.exists)(json, 'laser') ? undefined : (0, _1.StreemApiAnalyticEventToolLaserFromJSON)(json['laser']),
        'draw': !(0, runtime_1.exists)(json, 'draw') ? undefined : (0, _1.StreemApiAnalyticEventToolDrawFromJSON)(json['draw']),
        'flashlight': !(0, runtime_1.exists)(json, 'flashlight') ? undefined : (0, _1.StreemApiAnalyticEventToolFlashlightFromJSON)(json['flashlight']),
        'arrow': !(0, runtime_1.exists)(json, 'arrow') ? undefined : (0, _1.StreemApiAnalyticEventToolArrowFromJSON)(json['arrow']),
        'measure': !(0, runtime_1.exists)(json, 'measure') ? undefined : (0, _1.StreemApiAnalyticEventToolMeasureFromJSON)(json['measure']),
        'text': !(0, runtime_1.exists)(json, 'text') ? undefined : (0, _1.StreemApiAnalyticEventToolTextFromJSON)(json['text']),
        'model3d': !(0, runtime_1.exists)(json, 'model3d') ? undefined : (0, _1.StreemApiAnalyticEventToolModel3dFromJSON)(json['model3d']),
        'measureAnchor': !(0, runtime_1.exists)(json, 'measure_anchor') ? undefined : (0, _1.StreemApiAnalyticEventToolMeasurementAnchorFromJSON)(json['measure_anchor']),
    };
}
exports.StreemApiAnalyticEventToolPlacedFromJSONTyped = StreemApiAnalyticEventToolPlacedFromJSONTyped;
function StreemApiAnalyticEventToolPlacedToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'room_sid': value.roomSid,
        'call_status': value.callStatus,
        'laser': (0, _1.StreemApiAnalyticEventToolLaserToJSON)(value.laser),
        'draw': (0, _1.StreemApiAnalyticEventToolDrawToJSON)(value.draw),
        'flashlight': (0, _1.StreemApiAnalyticEventToolFlashlightToJSON)(value.flashlight),
        'arrow': (0, _1.StreemApiAnalyticEventToolArrowToJSON)(value.arrow),
        'measure': (0, _1.StreemApiAnalyticEventToolMeasureToJSON)(value.measure),
        'text': (0, _1.StreemApiAnalyticEventToolTextToJSON)(value.text),
        'model3d': (0, _1.StreemApiAnalyticEventToolModel3dToJSON)(value.model3d),
        'measure_anchor': (0, _1.StreemApiAnalyticEventToolMeasurementAnchorToJSON)(value.measureAnchor),
    };
}
exports.StreemApiAnalyticEventToolPlacedToJSON = StreemApiAnalyticEventToolPlacedToJSON;
/**
* @export
* @enum {string}
*/
var StreemApiAnalyticEventToolPlacedCallStatus;
(function (StreemApiAnalyticEventToolPlacedCallStatus) {
    StreemApiAnalyticEventToolPlacedCallStatus["NOCALL"] = "CALL_STATUS_NO_CALL";
    StreemApiAnalyticEventToolPlacedCallStatus["INCALL"] = "CALL_STATUS_IN_CALL";
    StreemApiAnalyticEventToolPlacedCallStatus["POSTCALL"] = "CALL_STATUS_POST_CALL";
    StreemApiAnalyticEventToolPlacedCallStatus["INVALID"] = "CALL_STATUS_INVALID";
})(StreemApiAnalyticEventToolPlacedCallStatus = exports.StreemApiAnalyticEventToolPlacedCallStatus || (exports.StreemApiAnalyticEventToolPlacedCallStatus = {}));
//# sourceMappingURL=StreemApiAnalyticEventToolPlaced.js.map